{
  "Announcements": "공지사항",
  "MarkAllAsRead": "모두 읽음으로 표시",
  "NoLinkNotification": "사용 가능한 이 알림의 링크 없음",
  "Notification": "알림",
  "ViewAll": "모두 보기"
}
